// extracted by mini-css-extract-plugin
export default {"limits":"TariffLimits_limits__XsWIc","limit":"TariffLimits_limit__QyXiW","limitOn":"TariffLimits_limitOn__NF9vk"};